import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_INVOICE = createActionTypes('FETCH_INVOICE');
export const DOWNLOAD_CHARGE_RCT = createActionTypes('FETCH_CHARGE_RCT');
export const FETCH_INVOICE_WIDGETS = createActionTypes('FETCH_INVOICE_WIDGETS');
export const DOWNLOAD_INVOICE = createActionTypes('DOWNLOAD_INVOICE');
export const DOWNLOAD_SINGLE_INVOICE = createActionTypes('DOWNLOAD_SINGLE_INVOICE');
export const DOWNLOAD_BULK_INVOICE = createActionTypes('DOWNLOAD_BULK_INVOICE');
export const GENERATE_CONSOLIDATED_INVOICE = createActionTypes('GENERATE_CONSOLIDATED_INVOICE');
export const RETRY_GENERATING_INVOICES = createActionTypes('RETRY_GENERATING_INVOICES');
